import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useProgressStore = defineStore('progress', () => {
  // State as individual refs
  const title = ref<string>('Progress');
  const totalsLabel = ref<string>('');
  const current = ref<number>(0);
  const total = ref<number>(1);
  const visible = ref<boolean>(false);

  // Getter as computed
  const progressPercentage = computed(() => {
    return Math.min(Math.round((current.value / total.value) * 100), 100);
  });

  // Actions as functions
  function setTitle(newTitle: string) {
    title.value = newTitle;
  }

  function setTotalsLabel(label: string) {
    totalsLabel.value = label;
  }

  function setCurrent(value: number) {
    current.value = value;
  }

  function setTotal(value: number) {
    total.value = value;
  }

  function show() {
    visible.value = true;
  }

  function hide() {
    visible.value = false;
  }

  function reset() {
    title.value = 'Progress';
    totalsLabel.value = '';
    current.value = 0;
    total.value = 1;
    visible.value = false;
  }

  function increment(amount = 1) {
    current.value = Math.min(current.value + amount, total.value);
  }

  return {
    // Expose refs
    title,
    totalsLabel,
    current,
    total,
    visible,
    progressPercentage,

    // Expose functions
    setTitle,
    setTotalsLabel,
    setCurrent,
    setTotal,
    show,
    hide,
    reset,
    increment
  };
});
